import { apiClient } from "../api/apiclient";

export const postSprintTeam = (team, token) =>
  apiClient.post("/create-sprint", team, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllSprints = (token) =>
  apiClient.get("/sprints", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllStory = (token) =>
  apiClient.get("/stories", {
    headers: { Authorization: `Bearer ${token}` },
  });
export const movePendingStories = (request, token) =>
  apiClient.put("/sprints/move-pending-stories", request, {
    headers: { Authorization: `Bearer ${token}` },
  });
